import React from "react";
import {Navigate} from "react-router-dom";
import {useAuth} from "./AuthContext";
import Spinner from "./Spinner/Spinner";

const PrivateRoute: React.FC<{ children: React.ReactNode }> = ({children}) => {
    const {loggedIn, loading} = useAuth();

    if (loading) {
        return <Spinner/>;
    }

    if (!loggedIn) {
        return <Navigate to="/login" replace/>;
    }

    return <>{children}</>;
};

export default PrivateRoute;

